import * as moment from 'moment';

import { GRANT_TYPES, GRANT_TYPES_ID, TYPES, TYPES_ID } from './friends-referral-api.constants';
import { IGetRewardsResponseItem } from './friends-referral-api.types';

export const checkRewardEligible = (rewardItem: IGetRewardsResponseItem) => {
    /* we only want to display referrer/both and not the invitee reward */
    const isInviteeGrantType = rewardItem.grantType === GRANT_TYPES_ID[GRANT_TYPES.INVITEE];
    const isActive = rewardItem.active;
    const isTrialType = rewardItem.type === TYPES_ID[TYPES.TRIAL];
    const isRetentionType = rewardItem.type === TYPES_ID[TYPES.RETENTION];
    return !isInviteeGrantType && isActive && !isTrialType && !isRetentionType;
};

/**
 * Dates received from server do not contain timezone information and should be considered as UTC.
 * Dates received from admin tool (beta flow only) have information about timezone, so moment.utc(...) will still work
 */
export const isBeforeExpiration = (date?: string | null) => {
    const expirationTime: moment.Moment = moment.utc(date);

    if (!date || !expirationTime.isValid()) {
        return true;
    }

    const localTime: moment.Moment = moment();
    return localTime.isBefore(expirationTime);
};
